import { LicenseInfo } from "@mui/x-license";
import React from "react";
import ReactDOM from "react-dom/client";

import { config } from "~root/config";

import { App } from "./App";

if (config.muiXLicenseKey) {
  LicenseInfo.setLicenseKey(config.muiXLicenseKey);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
